export const PROGRESS_COLOR = {
  bar: 'var(--brand-public-primary)',
  default: 'var(--accent-main-primary)'
};
export const BACKGROUND_COLOR = 'var(--surface-main-default)';